import { TextField, Button } from "@mui/material";
import { Message, MessageType } from "common/types";
import { useState } from "react";
import styled from "styled-components";
import sendLogo from "common/assets/images/sendLogo.svg";
import { useDispatch, useSelector } from "react-redux";
import { selectMessageSendInProgress, selectActiveInteractionId } from "../selectors";
import { setMessageSendInProgress } from "../slice";
import { setPromptModal } from "features/auth/slice";

const RescheduleRequestInput = () => {
  const [text, setText] = useState<string>("");
  const activeInteractionId = useSelector(selectActiveInteractionId);
  const dispatch = useDispatch();
  const isDisabled = useSelector(selectMessageSendInProgress) || text === "";

  const handleRescheduleClick = () => {
    dispatch(setPromptModal({ isOpen: true, ModalType: "REQUEST_RESCHEDULE" }));
  };
  const handleSendClick = () => {
    dispatch(setMessageSendInProgress(true));
    const message: Partial<Message> = {
      type: MessageType.TEXT,
      payload: text,
    };
    dispatch({
      type: "SEND_MESSAGE",
      payload: { 
        activeInteractionId,
        message,
      },
    })
    setText("");
  };

  return (
    <StyledWrapper>
      <TextField
        value={text}
        onChange={(e) => setText(e.target.value)}
        multiline
        rows={5}
        fullWidth
        variant="filled"
        placeholder="Write a response"
        className="thread-input"
        InputProps={{ disableUnderline: true }}
      />
      <div className="buttons">
        <Button variant="contained" color="primary" className={"reschedule-btn cursor-pointer button-margin"} onClick={handleRescheduleClick}> <div className="d-flex send-logo"> Request Reschedule 
        <svg className="reschedule-icon" width="16" height="16" viewBox="0 0 16 16"  xmlns="http://www.w3.org/2000/svg">
          <path d="M7.82808 5.81762e-08C6.45782 0.00726616 5.11322 0.371276 3.9273 1.05601C2.74138 1.74075 1.75525 2.72249 1.06647 3.90408C0.377698 5.08567 0.0101551 6.42618 0.000207437 7.79296C-0.00974022 9.15974 0.338253 10.5054 1.00975 11.6969C1.68126 12.8883 2.653 13.8842 3.82882 14.5861C5.00465 15.2879 6.34382 15.6713 7.71382 15.6985C9.08382 15.7256 10.4372 15.3954 11.64 14.7406C12.8428 14.0859 13.8534 13.1292 14.5717 11.9652C14.645 11.8468 14.6681 11.7042 14.636 11.5687C14.6038 11.4333 14.5191 11.3161 14.4003 11.243C14.2816 11.1699 14.1386 11.1469 14.0028 11.1789C13.867 11.211 13.7496 11.2955 13.6763 11.414C12.9155 12.6685 11.7703 13.6456 10.4099 14.2009C9.04952 14.7561 7.54611 14.8601 6.12192 14.4973C4.69772 14.1346 3.42832 13.3244 2.50134 12.1866C1.57435 11.0487 1.03898 9.64353 0.974358 8.17877C0.909732 6.714 1.31928 5.26736 2.14247 4.05268C2.96565 2.83799 4.15879 1.91971 5.54554 1.43357C6.93228 0.947427 8.43903 0.919223 9.84308 1.35313C11.2471 1.78703 12.474 2.66001 13.3423 3.84304L12.167 3.50461C12.1006 3.48606 12.0313 3.48072 11.9628 3.48892C11.8944 3.49711 11.8282 3.51867 11.7681 3.55236C11.7081 3.58605 11.6552 3.63122 11.6126 3.68529C11.57 3.73935 11.5385 3.80126 11.5199 3.86746C11.5013 3.93367 11.496 4.00288 11.5042 4.07115C11.5124 4.13941 11.534 4.2054 11.5678 4.26533C11.6016 4.32527 11.6469 4.37798 11.7011 4.42046C11.7553 4.46294 11.8173 4.49435 11.8837 4.51291L14.3321 5.21069C14.4655 5.24784 14.6081 5.23091 14.729 5.1636C14.8499 5.09628 14.9392 4.98404 14.9775 4.85133L15.677 2.40909C15.6972 2.34324 15.7042 2.27404 15.6976 2.20548C15.6909 2.13692 15.6708 2.07035 15.6383 2.00957C15.6058 1.9488 15.5616 1.89502 15.5082 1.85132C15.4548 1.80762 15.3933 1.77486 15.3272 1.75492C15.2705 1.73808 15.2115 1.73042 15.1523 1.73225C15.0402 1.73625 14.9323 1.77603 14.8444 1.84573C14.7566 1.91544 14.6935 2.0114 14.6644 2.11951L14.3041 3.37901C13.5784 2.3361 12.6102 1.484 11.4825 0.895562C10.3547 0.307123 9.10083 -0.000154366 7.82808 5.81762e-08ZM7.82808 2.43352C7.68893 2.43352 7.55548 2.48865 7.45709 2.5868C7.35869 2.68494 7.30342 2.81806 7.30342 2.95685V7.84133C7.30451 7.93756 7.3322 8.03163 7.38341 8.11319C7.43463 8.19474 7.5074 8.26063 7.59373 8.30361L11.0915 10.0481C11.1504 10.0851 11.2162 10.1101 11.2849 10.1216C11.3536 10.133 11.4239 10.1307 11.4917 10.1147C11.5595 10.0988 11.6235 10.0695 11.6798 10.0286C11.7362 9.98775 11.7838 9.93609 11.8199 9.87667C11.856 9.81724 11.8799 9.75123 11.8902 9.68249C11.9005 9.61376 11.8969 9.54367 11.8797 9.47632C11.8625 9.40897 11.8321 9.34571 11.7901 9.29022C11.7482 9.23474 11.6956 9.18815 11.6354 9.15316C11.6112 9.13922 11.5861 9.12698 11.5602 9.11653L8.35274 7.5221V2.96558C8.35508 2.82707 8.30227 2.69329 8.20589 2.59355C8.10951 2.49382 7.97742 2.43627 7.83857 2.43352H7.82808Z" />
        </svg> 
        </div> </Button>
        <Button variant="contained" disabled={isDisabled} color="primary" className="send-btn cursor-pointer button-margin" onClick={text.replace(/\s/g, "") !== "" ? handleSendClick : undefined}> <div className="d-flex send-logo"> Send Message <img className="justify-center send-icon" src={sendLogo} alt="" /></div> </Button>
      </div>
      <div className={"reschedule-message"}>
        <p>Please note - rescheduling interactions will be inconvenient for professionals, only request to reschedule this interaction if absolutely necessary</p>
      </div>
    </StyledWrapper>
  );
};

export default RescheduleRequestInput;

const StyledWrapper = styled.div`
  .send-btn {
    margin-left: auto;
    display: flex;
    margin-top: 30px;
    border: none;
    width: auto;
    height: 39px;
    justify-content: center;
    padding-top: 8px;
  }
  
  .send-icon {
    margin-left: 10px;
    position: relative;
    top: -5px;
  }
  .reschedule-btn-disabled  {
    float: right;
    margin-top: 30px;
    border: none;
    width: auto;
    height: 39px;
    justify-content: center;
    padding-top: 8px;
    background-color: white;
    color: #464fd0;
    fill: #fff;
  }
  .reschedule-btn{
    float: right;
    margin-top: 30px;
    border: none;
    width: auto;
    height: 39px;
    justify-content: center;
    padding-top: 8px;
    background-color: white !important;
    color: #464fd0;
    fill: #464fd0;
  }
  .reschedule-btn: hover {
    color: white;
    background-color: #464fd0;
    fill: #fff
  }
  .reschedule-icon{
    margin-left: 10px;
    margin-top: 3px;
    position: relative;
  }
  .send-logo {
    justify-content: center;
    margin: auto;
  }
  .thread-input {
    textarea,div {
      background: #F7F7F7;
    }
  }
  .button-margin {
    margin-left: 5px;
  }
  .reschedule-message {
    font-size: 13px;
    font-weight: 400;
    line-height: 18px;
    letter-spacing: 0px;
  }
  .buttons {
    display: flex;
    justify-content: flex-end;
  }
`;
